import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-could-not-load-survey',
  templateUrl: './could-not-load-survey.component.html',
  styleUrl: './could-not-load-survey.component.scss'
})
export class CouldNotLoadSurveyComponent implements OnInit {
  constructor(private router: Router) { }
  ngOnInit() {
    setTimeout(() => {
      this.router.navigate(['']);
    }, 3000);
  }
}
